import React from "react";

export default function IconCheckmarkCircle(props) {
  return (
    <svg viewBox="0 0 18 18" {...props} fill="none">
      <circle cx="9" cy="9" r="9" fill="#BC269B" />
      <path
        d="M5.40039 9.83825L7.20597 11.75L12.0671 6.75"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
